import React from 'react';

import {useStore} from 'effector-react';
import {Location} from 'history';
import {RouteProps} from 'react-router';
import {Redirect, Route} from 'react-router-dom';

import {ROUTE} from 'core/routes';
import {isAuth$, permissions$} from 'models/auth';
import {UserPermissionValue, UserRoles} from 'types';

import {hasAccess, hasAccessByRoles} from 'utils/roles';

interface Props extends RouteProps {
    permissions?: UserPermissionValue[];
    permissionAccessRoles?: UserRoles[];
    roles?: UserRoles[];
}

export function PrivateRoute({
    children,
    permissions,
    permissionAccessRoles,
    roles,
    path,
    ...rest
}: Props) {
    const isAuth = useStore(isAuth$);
    const currentPermissions = useStore(permissions$);

    const hasNoAccessByRole = !permissionAccessRoles || !hasAccessByRoles(permissionAccessRoles);

    const renderContent = (location: Location) => {
        if (!isAuth) return <Redirect to={{pathname: ROUTE.LOGIN, state: {from: location}}} />;

        if (
            path !== ROUTE.NO_ACCESS &&
            !hasAccess(currentPermissions, permissions) &&
            hasNoAccessByRole
        )
            return <Redirect to={{pathname: ROUTE.NO_ACCESS, state: {from: location}}} />;

        if (roles && !hasAccessByRoles(roles))
            return <Redirect to={{pathname: ROUTE.NO_ACCESS, state: {from: location}}} />;

        return children;
    };

    return <Route {...rest} render={({location}) => renderContent(location)} />;
}
